import React, { ReactNode } from 'react';

import { rem, Box } from '@vimeo/bokeh';
import { IBaseDomElementProps } from '@vimeo/core/types/dom';
import { Optional } from '@vimeo/core/types/generic';
import { graphicsConfig } from '@vimeo/live-core/configs/GraphicsConfig';

interface ISceneItemOverlay extends IBaseDomElementProps {
  color?: Optional<string>;
  width?: number;
  children?: ReactNode;
  borderStyle?: string;
  backgroundColor?: string;
  size?: 'sm' | 'md';
  borderRadius?: number | string;
  zIndex?: number | 'auto';
  backdropFilter?: string;
}

export function SceneItemOverlay({
  id,
  className,
  color,
  width = 4,
  children,
  borderStyle = 'solid',
  backgroundColor = 'transparent',
  size = 'md',
  borderRadius = 8,
  backdropFilter,
  zIndex = graphicsConfig.GRAPHICS_POSITIONING.Z_INDEX.SCENE_LABEL,
}: ISceneItemOverlay) {
  const isSizeMd = size === 'md';

  return (
    <Box
      id={id}
      className={className}
      position={'absolute'}
      left={isSizeMd ? rem(-4) : 0}
      top={isSizeMd ? rem(-4) : 0}
      width={isSizeMd ? `calc(100% + ${rem(8)})` : '100%'}
      height={isSizeMd ? `calc(100% + ${rem(8)})` : '100%'}
      borderRadius={typeof borderRadius === 'string' ? borderRadius : rem(borderRadius)}
      borderWidth={color ? rem(width) : undefined}
      borderStyle={color ? borderStyle || 'solid' : undefined}
      borderColor={color ? color : undefined}
      backdropFilter={backdropFilter}
      zIndex={zIndex}
      pointerEvents="none"
      alignItems="center"
      justifyContent="center"
      backgroundColor={backgroundColor || 'transparent'}
    >
      {children}
    </Box>
  );
}
